import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { NgxPrintModule } from 'ngx-print';

@Component({
    selector: 'lib-print-a11-template',
    imports: [
        MatButtonModule,
        MatIconModule,
        NgxPrintModule
    ],
    templateUrl: './print-A11-template.component.html',
    styleUrl: './print-A11-template.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PrintA11TemplateComponent { 

    hidePrintButtonInput = input<boolean>();
}
